module.exports = __webpack_public_path__ + "websocket.dc370b322a8cb768c358.worker.js"